import * as React from 'react';
import * as ReactDOM from 'react-dom';

import KendoBaseComponent, { KendoWidgetProps } from '@progress/kendo-base-component-react-wrapper';

export interface CalendarProps extends KendoWidgetProps, kendo.ui.CalendarOptions {
    children?: React.ReactNode;
}

export default class Calendar extends KendoBaseComponent<CalendarProps, {}> {
    componentDidMount(): void {
        const domNode = this.domNode;
        const { children, widgetRef, ...props } = this.props;

        if (domNode) {
            this.widgetInstance = new kendo.ui.Calendar(domNode as Element, (props as kendo.ui.CalendarOptions));
            super.componentDidMount();
        }
    }

    render(): any {
        if (this.didMount) {
            const { children, widgetRef, ...props } = this.props;

            this.widgetInstance.setOptions(props);
            (this.widgetInstance as kendo.ui.Calendar).value(props.value as Date);
        }

        const domChild = React.Children
            .toArray(this.props.children)
            .filter((child: React.ReactElement<any>) => child && (child.type === 'div'))
            .shift();

        return domChild
            ? React.cloneElement(domChild, { ...domChild.props, ref: this.elementRef })
            : <div ref={this.elementRef} />;
    }
}



// WEBPACK FOOTER //
// ./packages/kendo-dateinputs-react-wrapper/src/calendar/index.tsx